import { Box, Grid, Typography, Paper, Chip, useMediaQuery } from "@mui/material";
import { EmojiEmotions, Cancel, Edit, Handshake } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const DiscountInfo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ backgroundColor: "#EEF2FA", p: isMobile ? 3 : 6, borderRadius: 2 }}>
      <Grid container spacing={isMobile ? 2 : 4}>
        {/* Discount Section */}
        <Grid item xs={12} md={6}>
          <Box sx={{ backgroundColor: "#fff", p: isMobile ? 3 : 5, borderRadius: 2 }}>
            <Typography color="#173a8b" fontWeight="bold">
              Save up to 20%
            </Typography>
            <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" gutterBottom>
              Ride <span style={{ color: "#173a8b" }}>More</span>{" "}
              <span style={{ color: "#173a8b" }}>Save</span> More
            </Typography>

            {/* Discount List */}
            <Box sx={{ my: 2 }}>
              {[
                { days: "1 - 2 Days", label: "Standard Rate" },
                { days: "2 - 5 Days", label: "5% Discount" },
                { days: "6 - 10 Days", label: "10% Discount" },
                { days: "10 - 15 Days", label: "15% Discount" },
                { days: "Above 15 Days", label: "20% Discount" },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: index < 4 ? "1px solid #ddd" : "none",
                  }}
                >
                  <Typography fontWeight="500" color="#000">{item.days}</Typography>
                  <Chip label={item.label} sx={{ backgroundColor: "#F4B400", color: "#fff", fontWeight: "bold" }} />
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>

        {/* Features Section */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {[
              {
                title: "Free cancellation",
                description: "GO HIMACHAL Taxi Service let you cancel the trip one week prior to your departure without any charges.",
                icon: <Cancel sx={{ color: "#173a8b" }} />,
              },
              {
                title: "Tour Customisation",
                description: "We let our travelers customize their trip as per their choice while charging reasonable price.",
                icon: <Edit sx={{ color: "#173a8b" }} />,
              },
              {
                title: "Satisfaction Guaranteed",
                description: "We assure you of quality service and a memorable experience with Shimla Manali Taxi Service.",
                icon: <EmojiEmotions sx={{ color: "#173a8b" }} />,
              },
              {
                title: "Easy Refunds",
                description: "For the last minute cancellations we have easy refunds policy which takes no time to process.",
                icon: <Handshake sx={{ color: "#173a8b" }} />,
              },
            ].map((feature, index) => (
              <Grid item xs={12} sm={6} key={index} sx={{marginTop:'4%'}}>
                <Paper
                  sx={{
                    p: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    top:3
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#F4B400",
                      p: 1.5,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      top:4,
                  
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Box>
                    <Typography fontWeight="bold" color="#000">
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="gray">
                      {feature.description}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DiscountInfo;
